import { Injectable } from '@angular/core';
import { satisfies } from 'semver';

import { Observable, map } from 'rxjs';
import { ApplicationQuery } from '../state/application/application.query';

/** Feature version range. */
type FeatureVersionRange = string;

/** Supported Features Service. */
@Injectable({
  providedIn: 'root',
})
export class SupportedFeaturesService {
  /** Bulk CSv update range. */
  readonly bulkCsvUpdate: FeatureVersionRange = '>=6.3.352';
  /** Bulk update range. */
  readonly bulkUpdate: FeatureVersionRange = '>=6.3.347';
  /** Bulk update open erorred range. */
  readonly bulkUpdateOpenErroredDocuments: FeatureVersionRange = '>=6.3.367';
  /** Enhanced export all range. */
  readonly enhancedExportAll: FeatureVersionRange = '>=6.3.348';
  /** Enhanced export data only range. */
  readonly enhancedExportDataOnly: FeatureVersionRange = '>=6.3.358';
  /** Enhanced export include all table data range. */
  readonly enhancedExportIncludeAllTableData: FeatureVersionRange = '>=6.3.358';
  /** Internal viewer imports range. */
  readonly internalViewerImports: FeatureVersionRange = '>=6.3.191';
  /** Modify documents range. */
  readonly modifyDocuments: FeatureVersionRange = '>=6.3.332';
  /** Share button range. */
  readonly shareLinks: FeatureVersionRange = '>=6.3.319';
  /** Annotations drawing support. */
  readonly annotationsDrawing: FeatureVersionRange = '>=6.3.339';
  /** Update multiple search results range. */
  readonly updateMultipleSearchResults: FeatureVersionRange = '>=6.3.353';

  constructor(private appQuery: ApplicationQuery) {}

  /**
   * Determines whether a feature is supported in the current API version.
   *
   * @param feature Feature.
   * @returns True if the current version supports the feature.
   */
  versionSupports(feature: FeatureVersionRange): boolean {
    return satisfies(this.appQuery.apiVersion, feature);
  }

  /**
   * Creates an observable that can be used to determine whether a feature is supported in the current API version.
   *
   * @param feature Feature.
   * @returns An observable which resolves as true if the current version supports the feature.
   */
  versionSupports$(feature: FeatureVersionRange): Observable<boolean> {
    return this.appQuery.apiVersion$.pipe(
      map((apiVersion) => satisfies(apiVersion, feature))
    );
  }
}
